<template>
   <div>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow.smtppro" data-app="true" persistent max-width="900">
      <v-card>

       <CardUpdatableHeader :row="row" :level="level"/>

        <v-card-text>
          <v-container>
            <h4>{{ $t('subtitles.counting_method') }}</h4>
            <v-row no-gutters>
               <v-col cols="12">
                  <v-select
                     :items="items_methods"
                     items-disabled="disabled"
                     type="number"
                     :value="row.xxx_method"
                     :disabled="level.dialogValues.form_delete"
                     :label="$t('texts.xxx_method')"
                     v-on:change="change_method"
                  >
                  </v-select>
               </v-col>
            </v-row>
            <h4>{{ $t('subtitles.settings') }}</h4>
            <div v-if="row.xxx_method==1">
               <v-row v-if="row.xxx_maxusers!=1" no-gutters>
               <v-col cols="12" sm="4">
                     <v-select
                        :items="items_accounts"
                        items-disabled="disabled"
                        type="number"
                        :value="row.xxx_maxusers"
                        :disabled="level.dialogValues.form_delete"
                        :label="$t('texts.xxx_maxusers')"
                        v-on:change="change_maxusers"
                     >
                     </v-select>
               </v-col>
               <v-col cols="12" sm="4">
                     <v-select
                        :items="items_emails"
                        type="number"
                        :value="row.xxx_max_emails_per_month"
                        :disabled="level.dialogValues.form_delete"
                        :label="$t('texts.xxx_max_emails_per_month')"
                        v-on:change="change_maxemails"
                     >
                     </v-select>
               </v-col>
               <v-col cols="12" sm="4">
                     <v-select
                        :items="items_gigabytes"
                        type="number"
                        :value="row.xxx_max_gigabytes_per_month"
                        :disabled="level.dialogValues.form_delete"
                        :label="$t('texts.xxx_max_gigabytes_per_month')"
                        v-on:change="change_maxgigabytes"
                     >
                     </v-select>
               </v-col>
               </v-row>
               <v-row v-if="row.xxx_maxusers==1" no-gutters>
               <v-col cols="12" sm="6">
                     <v-select
                        :items="items_emails"
                        type="number"
                        :value="row.xxx_max_emails_per_month"
                        :disabled="level.dialogValues.form_delete"
                        :label="$t('texts.xxx_max_emails_per_month')"
                        v-on:change="change_maxemails"
                     >
                     </v-select>
               </v-col>
               <v-col cols="12" sm="6">
                     <v-select
                        :items="items_gigabytes"
                        type="number"
                        :value="row.xxx_max_gigabytes_per_month"
                        :disabled="level.dialogValues.form_delete"
                        :label="$t('texts.xxx_max_gigabytes_per_month')"
                        v-on:change="change_maxgigabytes"
                     >
                     </v-select>
               </v-col>
               </v-row>
            </div>
            <div v-if="row.xxx_method==2">
               <v-row no-gutters>
                  <v-col cols="6" sm="6">
                     <v-text-field dense v-model="row.xxx_counter1_current" type="number" disabled="true">
                     </v-text-field>
                     <v-text-field dense v-model="row.xxx_counter1_max" type="number" disabled="true">
                     </v-text-field>
                  </v-col>
               </v-row>
            </div>
            <v-row no-gutters>
               <v-col cols="6" sm="6">
                  <v-row :disabled="level.dialogValues.form_delete">
                     <v-col cols="4"><v-checkbox v-model="xxx_sasl_smtppro"     dense hide-details label="SMTP Pro" :disabled="level.dialogValues.form_delete" v-on:change="recheck_bulk_fields"></v-checkbox></v-col>
                     <v-col cols="4"><v-checkbox v-model="xxx_sasl_smtppronews" dense hide-details label="SMTP Pro News" :disabled="level.dialogValues.form_delete" v-on:change="recheck_bulk_fields"></v-checkbox></v-col>
                     <v-col cols="4"><v-checkbox v-model="xxx_sasl_smtpprospec" dense hide-details label="SMTP Pro Specific" :disabled="level.dialogValues.form_delete" v-on:change="recheck_bulk_fields"></v-checkbox></v-col>
                  </v-row>
                  <v-row :disabled="level.dialogValues.form_delete">
                     <v-col cols="12"><v-checkbox v-model="row.xxx_can_change_dkim_selector" dense hide-details :label="$t('texts.xxx_can_change_dkim_selector')" :disabled="level.dialogValues.form_delete"></v-checkbox></v-col>
                  </v-row>

               </v-col>
            </v-row>
            <v-row no-gutters>
               <v-col cols="12" sm="6">
                  <v-switch
                     dense
                     v-model="row.xxx_suspend_on_threshold"
                     :label="$t('texts.xxx_suspend_on_threshold')"
                     :disabled="level.dialogValues.form_delete"
                  >
                  </v-switch>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-switch
                     dense
                     v-model="row.xxx_active"
                     :label="isActiveLabel"
                     :disabled="level.dialogValues.form_delete"
                     @change="changeActive" 
                  >
                  </v-switch>
                  <div v-if="row.xxx_suspended_since!=null">
                     {{ $t('texts._suspended_since') }} : <strong><mark>{{ $api._d(row.xxx_suspended_since,'long') }}</mark></strong><br/>
                  </div>
                  <template v-if="row.xxx_expiration_date!=null">
                     {{ $t('texts._expired_on') }} : <strong><mark>{{ $api._d(row.xxx_expiration_date,'long') }}</mark></strong>
                  </template>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="6" sm="6" v-if="showhide_addaccount==true && level.dialogValues.form_delete!=true">
                  <h4>{{ $t('subtitles.addaccount') }}</h4>
                  <v-text-field dense v-model="xxx_sasl_username" @input="check_userfields" maxlength="80" counter :disabled="level.dialogValues.form_disabled" :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules">
                  </v-text-field>
                  <v-text-field dense v-model="xxx_sasl_password" @input="check_userfields" maxlength="40" :append-icon="show_pwd ? 'mdi-eye' : 'mdi-eye-off'" :type="show_pwd ? 'text' : 'password'" @click:append="show_pwd=!show_pwd" :label="$t('texts.signin_password')"  required :hint="$t('hints.signin_password')">
                  </v-text-field>
                  <v-btn small class="primary" rounded @click="generate_password">{{ $t('buttons.generate_password') }}</v-btn>
                  <v-btn :disabled="button_adduser_disabled" small rounded class="primary" @click="add_username">{{ $t('buttons.create') }}</v-btn>
               </v-col>
               <v-col cols="auto">
                  <h4 v-if="row.xxx_maxusers==1">{{ $t('subtitles.listaccount') }}</h4>
                  <h4 v-else>{{ $t('subtitles.listaccounts') }}</h4>
                  <ddoSelect
                     key="mainSwitchUsernames"
                     :callbacks="callbacks" 
                     :options="options"
                     ref="mySelectUsernames"
                  >

                     <template v-slot:selection="data">
                        <v-chip
                           v-bind="data.attrs"
                           :input-value="data.selected"
                           close
                           @click:close="$refs.mySelectUsernames.remove(data.item)"
                        >
                           <span v-text="data.item.username"></span>
                        </v-chip>
                     </template>

                     <template v-slot:item="data">
                        <v-list-item-content>
                           <v-list-item-title v-html="data.item.username"></v-list-item-title>
                        </v-list-item-content>
                     </template>

                  </ddoSelect>

               </v-col>
            </v-row>

            <h4>{{ $t('subtitles.inform_by_mail_of_excess') }}</h4>
            <v-row no-gutters>
               <v-col cols="12" sm="6">
                  <v-select
                     :items="items_warn_levels"
                     items-disabled="disabled"
                     type="number"
                     :value="row.xxx_inform_warn_level"
                     :disabled="level.dialogValues.form_delete"
                     :label="$t('texts.xxx_inform_warn_level')"
                     v-on:change="change_warnlevel"
                  >
                  </v-select>
               </v-col>
            </v-row>

            <h5>{{ $t('subtitles.inform_to_customer') }} :</h5>
            <v-row no-gutters>
               <v-col cols="12" sm="6">
                  <v-text-field dense v-model="row.xxx_inform_to_emails" maxlength="400" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_inform_to_emails')" :hint="$t('hints.xxx_inform_to_emails')"></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                 <ddoSelectMailprofile :callbacks="MPRTOcallbacks" ref="mySelectMPRTO" :disabled="row.xxx_inform_to_emails==null" :options="MPRTOoptions"/>
               </v-col>
            </v-row>
            <h5>{{ $t('subtitles.inform_to_manager') }} :</h5>
            <v-row>
               <v-col cols="12" sm="6">
                  <v-text-field dense v-model="row.xxx_inform_cc_emails" maxlength="400" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_inform_cc_emails')" :hint="$t('hints.xxx_inform_cc_emails')"></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                 <ddoSelectMailprofile :callbacks="MPRCCcallbacks" ref="mySelectMPRCC" :options="MPRCCoptions"/>
               </v-col>
            </v-row>

             <v-row>
              <v-col v-if="!level.dialogValues.form_create" cols="auto">
                <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}<br/>
                <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}
              </v-col>
            </v-row>

        </v-container>
          <small>*{{ $t('texts.requiredfield') }}</small>
        </v-card-text>

        <CardUpdatableFooterConfirm :row="row" :level="level">
          <template v-slot:content="props">
            <p>Vous avez demandé :<br/><br/>
            <template v-if="old_users.length>0">
               - la suppression de :<br/>
                  <span v-html="old_users_html"></span><br/>
               <br/>
            </template>
            <template v-if="new_users.length>0">
               - la création de :<br/>
                  <span v-html="new_users_html"></span><br/>
               <br/>
            </template>
            En cliquant sur OK, vous validez cette demande,
            En cliquant sur cancel, vous revenez sur la fiche pour de nouvelles modifications.
            </p>
          </template>
        </CardUpdatableFooterConfirm>

      </v-card>
   </v-dialog>
   </div>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooterConfirm from '@/components/partials/CardUpdatableFooterConfirm.vue';
import ddoSelect from '@/components/ddoSelect.vue';
import ddoSelectMailprofile from '@/components/ddoSelectMailprofile.vue';

export default {
   name: 'CardUpdatableCUSPLFSMTPPRO',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooterConfirm,
      ddoSelect,
      ddoSelectMailprofile,
   },

   props: {
   },

   data: function () {
      return {
         show_pwd: false,
         current_usercount: null,
         min_username_length: 6,
         min_password_length: 8,
         button_adduser_disabled: false,
         xxx_sasl_username: null,
         xxx_sasl_password: null,
         xxx_sasl_smtppro: false,
         xxx_sasl_smtppronews: false,
         xxx_sasl_smtpprospec: false,
         initial_bulk_fields: null,
         new_users: [],
         old_users: [],
         new_users_html : '',
         old_users_html : '',
         _pk_to_add: 0,
         editWarning: false,

         MPRTOcallbacks: {},
         MPRTOoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "mpr_name",
            item_value: "mpr_pk",
            item_disabled: "",
            hide_selected: true,
            filter_by_platform: { plf_pk: null, exclusive: true },
            label: i18n.t('texts.xxx_mailprofile_to'),
        },

         MPRCCcallbacks: {},
         MPRCCoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "mpr_name",
            item_value: "mpr_pk",
            item_disabled: "",
            hide_selected: true,
            filter_by_platform: { plf_pk: null, exclusive: true },
            label: i18n.t('texts.xxx_mailprofile_cc'),
        },

         callbacks: {
         },

         options: {
            initial: [],
            disabled: false,
            multiple: true,
            clearable: false,
            item_text: "username",
            item_value: "username",
            item_disabled: "",
            hide_selected: true,
            switch_myself: false,
         },

         items_accounts: [],

         disabledItems_accounts: [],
         items_methods: [ { value: 1, text: i18n.t('texts.method_recurrent') }, { value: 2, text: i18n.t('texts.method_quota') } ],
         items_warn_levels: [ { value: 0, text: i18n.t('texts.level_ok') }, { value: 1, text: i18n.t('texts.level_warning') }, { value: 2, text: i18n.t('texts.level_error') }  ],
         items_emails: [ 
            { value:     100, text:       '100' }, 
            { value:     300, text:       '300' }, 
            { value:    3000, text:     '3 000' }, 
            { value:   10000, text:    '10 000' }, 
            { value:   50000, text:    '50 000' }, 
            { value:  100000, text:   '100 000' }, 
            { value:  200000, text:   '200 000' }, 
            { value:  250000, text:   '250 000' }, 
            { value:  500000, text:   '500 000' }, 
            { value: 1000000, text: '1 000 000' }, 
            { value: 1500000, text: '1 500 000' }, 
            { value: 2000000, text: '2 000 000' }, 
            { value:    null, text: '(unlimited)' } 
         ],
         items_gigabytes: [ { value: 1, text: '1 GB' }, { value: 10, text: '10 GB' }, { value: 50, text: '50 GB' }, { value: null, text: '(unlimited)' } ],
         suspend_on_threshold: false,
      }
   },

   created() {
      /*
       * We need to quickly store/keep the 'row.xxx_bulk_fields' value, because
       *  ' build_array_usernames' method will be called in sequence
       *  and this method calls also 'recheck_elements', which
       *  in turn, rebuild the 'row.xxx_bulk_fields'
       */
      if ( this.row.xxx_bulk_fields!=null ) {
         this.initial_bulk_fields = this.row.xxx_bulk_fields;
      }
      this.callbacks.refresh_rows = this.build_array_usernames;
      this.callbacks.remove = this.remove_username;
      this.items_accounts = this.init_items_account();
      this.MPRTOcallbacks.refresh_rows = this.build_select_mpr;
      this.MPRTOcallbacks.change = this.change_mpr_to;
      this.MPRCCcallbacks.refresh_rows = this.build_select_mpr;
      this.MPRCCcallbacks.change = this.change_mpr_cc;
   },

   mounted() {
      this.options.disabled = this.level.dialogValues.form_delete;
      /*
       * If we are in 'delete', we need to build array and string
       * required by the "confirm" dialog (CardUpdatableFooterConfirm)
       * We build them by using the string 'this.row.xxx_sasl_usernames'
       */
      if ( this.level.dialogValues.form_delete ) {
         if ( this.row.xxx_sasl_usernames!=null ) {
            var list = this.row.xxx_sasl_usernames.split(',');
            this.old_users = [];
            for ( var i=0; i<list.length;i++ ) {
               this.old_users.push( { _pk: i, username: list[i] } );
            }
         }
         this.recheck_elements();
      }

      /*
       * If we are in 'create', we force the following flags to true :
       * - xxx_suspend_on_threshold
       * - isActive (=> row.xxx_expiration_date)
       */
      if ( this.level.dialogValues.form_create ) {
         this.row_active = true;
         this.row.xxx_suspend_on_threshold = true;
         this.recheck_elements();
      }

      /*
       * If we are in 'update' or 'delete', we must retrieve the pro/pronews/prospec checkboxes
       */
      if ( this.level.dialogValues.form_update || this.level.dialogValues.form_delete ) {
         if ( this.initial_bulk_fields!=null ) {
            var bulk_fields = this.initial_bulk_fields.split(',');
            this.xxx_sasl_smtppro     = (bulk_fields.indexOf('pro')>=0 ? true:false );
            this.xxx_sasl_smtppronews = (bulk_fields.indexOf('pronews')>=0 ? true:false );
            this.xxx_sasl_smtpprospec = (bulk_fields.indexOf('prospec')>=0 ? true:false );
         }
         this.recheck_elements();
      }

      this.$refs.mySelectMPRTO.refresh_rows();
      this.$refs.mySelectMPRCC.refresh_rows();
      if ( this.level.row.mpr_pk!=null ) {
         this.MPRTOoptions.initial = this.level.row.mpr_pk;
      }
      if ( this.level.row.mpr_pk_cc!=null ) {
         this.MPRCCoptions.initial = this.level.row.mpr_pk_cc;
      }
      if ( this.level.row.plf_pk!=null ) {
         this.MPRTOoptions.filter_by_platform.plf_pk = this.level.row.plf_pk;
         this.MPRCCoptions.filter_by_platform.plf_pk = this.level.row.plf_pk;
      } else {
         this.MPRTOoptions.filter_by_platform.plf_pk = null;
         this.MPRCCoptions.filter_by_platform.plf_pk = null;
      }
   },

   computed: {
      showhide_addaccount: function() {
         return this.current_usercount<this.row.xxx_maxusers
      },
      isActiveLabel: function() {
         if ( this.row.xxx_active==true ) {
            return i18n.t('texts._activated')
         } else {
            return i18n.t('texts._deactivated')
         }
      }
   },

   /*
    * This is the best way to watch an Object :
    * - set a hanlder on it,
    * - and, most important : deep=true to watch over properties
    */ 
   watch: {
      row: {
         handler: function (val,oldVal) {
            this.loadOtherInformations(val,oldVal)
         },
         deep: true
      }
   },

   methods: {

      loadOtherInformations(row,oldRow) {
         console.log('loadOtherInformations, row='+JSON.stringify(row))
         this.MPRTOoptions.filter_by_platform.plf_pk = row.plf_pk;
         this.MPRCCoptions.filter_by_platform.plf_pk = row.plf_pk;
         this.$refs.mySelectMPRTO.refresh_rows();
         this.$refs.mySelectMPRCC.refresh_rows();
      },

      changeActive(value) {
         if ( value==true ) {
            this.row.xxx_expiration_date = null;
         }
      },

      init_items_account: function() {
         var result = [];
         var max_accounts = 8;
         var item0 = { value:0,text:'0',disabled:false}
         for ( var i=0;i<max_accounts;i++) {
            result[i] = JSON.parse(JSON.stringify(item0));
            result[i].value = i+1;
            result[i].text = result[i].value.toString();
         }
         return result
      },

      async build_select_mpr(key=null) {
         this.loading = true;
         var parameters = {};
         if ( this.MPRTOoptions.filter_by_platform.plf_pk !=null ) {
            parameters = { plf_pk: this.MPRTOoptions.filter_by_platform.plf_pk }
         }
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'mailprofile',parameters);
         this.loading = false;
         return { errorinfos, api_response }
      },
      async change_mpr_to(value,item=null) {
         if ( item!=null) {
            this.level.row.mpr_pk = item.mpr_pk;
         } else {
           this.level.row.mpr_pk = null;
         }
      },
      async change_mpr_cc(value,item=null) {
         if ( item!=null) {
            this.level.row.mpr_pk_cc = item.mpr_pk;
         } else {
           this.level.row.mpr_pk_cc = null;
         }
      },
      async change_active(value) {
         if ( value ) { this.level.row.xxx_active=true; } else { this.level.row.xxx_active=false; }
      },

      check_userfields() {
         if ( typeof this.xxx_sasl_username=="undefined" || typeof this.xxx_sasl_password=="undefined" ) {
            this.button_adduser_disabled = true;
            return;
         }
         var enabled =
            this.xxx_sasl_username!=null && this.xxx_sasl_username.length>=this.min_username_length &&
            this.xxx_sasl_password!=null && this.$api._check_password(this.xxx_sasl_password,2);
         this.button_adduser_disabled = !enabled;
      },

      generate_password() {
         this.xxx_sasl_password = this.$api._generate_password(2);
      },

      buid_html_table(array,withpassword=true) {
         var result = '';
         if ( array.length>0 ) {
            if ( withpassword ) {
               result += '<table border=1><tr><th>Username</th><th>Password</th></tr>';
            } else {
               result += '<table border=1><tr><th>Username</th></tr>';
            }
            for ( var i=0;i<array.length;i++ ) {
               if ( withpassword ) {
                  result += '<td>'+array[i].username+'</td><td>'+array[i].password+'</td></tr>';
               } else {
                  result += '<td>'+array[i].username+'</td><td></tr>';
               }
            }
            result += '</table>';
         }
         return result;
      },

      recheck_bulk_fields() {
         var bulk_fields = [];
         if ( this.xxx_sasl_smtppro     ) { bulk_fields.push('pro'); }
         if ( this.xxx_sasl_smtppronews ) { bulk_fields.push('pronews'); }
         if ( this.xxx_sasl_smtpprospec ) { bulk_fields.push('prospec'); }
         this.level.row.xxx_bulk_fields = bulk_fields.join(',');

      },

      recheck_elements() {
         this.current_usercount = this.options.initial.length;
         for ( var i=0;i<this.items_accounts.length;i++) {
            this.items_accounts[i].disabled = ( this.items_accounts[i].value<this.current_usercount ? true : false );
         }
         this.check_userfields();
         this.new_users_html = this.buid_html_table(this.new_users,true);
         this.old_users_html = this.buid_html_table(this.old_users,false);
         if ( this.new_users.length==0 && this.old_users.length==0 ) {
            this.level.row.xxx_changes_sasl_usernames = null;
         } else {
            this.level.row.xxx_changes_sasl_usernames = { insert: this.new_users, delete: this.old_users }
         }
         if ( this.level.dialogValues.form_create==true ) {
            this.level.dialogValues.create_btn_disabled = ( this.current_usercount==0 ? true:false );
         }
         this.recheck_bulk_fields();
      },

      change_method(value) {
         this.row.xxx_method = value;
      },

      change_maxusers(value) {
         this.row.xxx_maxusers = value;
      },

      change_warnlevel(value) {
         this.row.xxx_inform_warn_level = value;
      },

      change_maxemails(value) {
         this.row.xxx_max_emails_per_month = value;
      },

      change_maxgigabytes(value) {
         this.row.xxx_max_gigabytes_per_month = value;
      },

      build_array_usernames() {
         var data = [];

         /*
          * We create an array of objects, one for each username, to be used by <ddoSelect>
          * BUT (BUT!) :
          * - there must be a property of _pk, for each object
          * - this _pk must start to 1. If equals to 0, row cannot be deleted
          */
         if ( this.row.xxx_sasl_usernames!=null ) {
            for (var i=0;i<this.row.array_usernames.length;i++) {
               data.push({ _pk: i+1, username: this.row.array_usernames[i] });
            }
         }
         this.options.initial = data;
         /*
          * 'this._pk_to_add' will be the future _pk to add.
          * so, must be equal to length+1
          */
         this._pk_to_add = this.options.initial.length+1;
         this.recheck_elements();

         return { errorinfos: 0, api_response: { error: 0, rows: data } }
      },

      add_username() {
         if ( typeof this._pk_to_add=='undefined') {
            this._pk_to_add=1;
         }
         var _pk_to_add = this._pk_to_add;
         this.new_users.push( {
            _pk: _pk_to_add,
            username: this.xxx_sasl_username,
            password: this.xxx_sasl_password,
         });
         let _pk = this.$api._get_pk_by_value(this.options.initial,this.xxx_sasl_username,'username');
         if ( _pk==null ) {
            this.options.initial.push({ _pk: _pk_to_add, username: this.xxx_sasl_username });
            this._pk_to_add++;
         }
         this.recheck_elements();
      },

      remove_username(item) {
         var username = item.username;

         if ( username!=null ) {
            /*
             * We retrieve the _pk of the user to remove in 'new_users' array, and remove it from 'new_users'
             */
            var _pk1 = this.$api._get_pk_by_value(this.new_users,username,'username');
            if ( _pk1!=null ) {
               this.$api._remove_by_pk(this.new_users,_pk1);
            }
            /*
             * We retrieve the _pk of the user to add in 'old_users' array, and add it from 'old_users'
             * But there is no need to do that if we are in creation mode
             */
            if ( this.level.dialogValues.form_create!=true ) {
               var _pk2 = this.$api._get_pk_by_value(this.old_users,username,'username');
               if ( _pk2!=null ) {
                  this.$api._remove_by_pk(this.old_users,_pk2);
               }
               this.old_users.push(JSON.parse(JSON.stringify(item)));
            }
            var _pk3 = this.$api._get_pk_by_value(this.options.initial,username,'username');
            if ( _pk3!=null ) {
               this.$api._remove_by_pk(this.options.initial,_pk3);
            }
            this.recheck_elements();
         }
      },

   }
}
</script>